import React from 'react';
import Layout from '../../components/Layout/Layout';
import DiscoverSection from '../../components/DiscoverSection/DiscoverSection';
import styles from './DiscoverSectionPage.module.css';

const DiscoverSectionPage = () => {
  return (
    <Layout width="1440px">
      <div className={styles.discoverSectionStack}>
        <DiscoverSection 
          componentSize="Desktop 1440"
        />
      </div>
    </Layout>
  );
};

export default DiscoverSectionPage;